import { View } from "binder"
import { ImageEditorViewModel } from "./imageEditor-viewModel"

export class ImageEditorView extends View<ImageEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-B2CABD0B-CD54-4D2F-82AE-78B783996770"
    }
    loadHtml(): string {
        let element = require('./imageEditor.html').default;
        let style = require('./imageEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;

}
